import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
    getTodayFinances as getTodayFinancesEndpoint, 
    getFinances as getFinancesEndpoint, 
    getGeneralFinances as getGeneralFinancesEndpoint,
    getDailyReport as getDailyReportEndpoint,
    getWeeklyReport as getWeeklyReportEndpoint,
    getMonthlyReport as getMonthlyReportEndpoint,
    getYearlyReport as getYearlyReportEndpoint,
    getSalesDetails as getSalesDetailsEndpoint
} from "../../helpers/fakebackend_helper";

export const getFinances = createAsyncThunk("finance/getFinances", async () => {
    try {
        return getFinancesEndpoint();
    }
    catch (error) {
        return error;
    }
});

export const getTodayFinances = createAsyncThunk("finance/getTodayFinances", async () => {
    try {
        return getTodayFinancesEndpoint();
    }
    catch (error) {
        return error;
    }
});

export const getGeneralFinances = createAsyncThunk("finance/getGeneralFinances", async () => {
    try {
        return getGeneralFinancesEndpoint();
    }
    catch (error) {
        return error;
    }
});

export const getDailyReport = createAsyncThunk("finance/getDailyReport", async ({ startDate, endDate }) => {
    try {
        return getDailyReportEndpoint(startDate, endDate);
    }
    catch (error) {
        return error;
    }
});

export const getWeeklyReport = createAsyncThunk("finance/getWeeklyReport", async ({ startDate, endDate }) => {
    try {
        return getWeeklyReportEndpoint(startDate, endDate);
    }
    catch (error) {
        return error;
    }
});

export const getMonthlyReport = createAsyncThunk("finance/getMonthlyReport", async ({ startDate, endDate }) => {
    try {
        return getMonthlyReportEndpoint(startDate, endDate);
    }
    catch (error) {
        return error;
    }
});

export const getYearlyReport = createAsyncThunk("finance/getYearlyReport", async ({ startDate, endDate }) => {
    try {
        return getYearlyReportEndpoint(startDate, endDate);
    }
    catch (error) {
        return error;
    }
});

export const getSalesDetails = createAsyncThunk("finance/getSalesDetails", async ({ startDate, endDate }) => {
    try {
        return getSalesDetailsEndpoint(startDate, endDate);
    }
    catch (error) {
        return error;
    }
});